// import MicIcon from '@mui/icons-material/Mic';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { handleSaveJournalChat } from '../../utils/api';
import { toast } from 'react-toastify';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '../../svg/DeleteIcon';
// import StopIcon from '@mui/icons-material/Stop';
// import useSTT from './useSTT';
// import AudioMeter from './AudioMeter';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';

const JournalEntryForm = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [saving, setSaving] = useState(false);
    const [showDiscard, setShowDiscard] = useState(false);
    const titlePlaceholder = 'Write your journal title here';
    const contentPlaceholder = 'Write or paste your journal entry here. This information will be used to train your AI Personas knowledge and personality.';
    const { authUser } = useAuth();
    const navigate = useNavigate();
    const theme = useTheme();
    const [timestamp, setTimestamp] = useState('');

    // const {
    //     micAvailable,
    //     micPermissionAllowed,
    //     listening,
    //     transcribing,
    //     connecting,
    //     transcript,
    //     start,
    //     stop,
    //     clear,
    //     errorOccurred,
    //     errorMsg,
    // } = useSTT();

    const lastLength = useRef(0);

    useEffect(() => {
        const now = new Date();
        setTimestamp(
            now.toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            })
        );
    }, []);

    // useEffect(() => {
    //     if (transcript.length > lastLength.current) {
    //         const newText = transcript.substring(lastLength.current);
    //         setContent((prev) => prev + newText);
    //         lastLength.current = transcript.length;
    //     }
    // }, [transcript]);

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await saveEntry(title, content);
        } catch (error) {
            console.log(error);
        }
    };

    const saveEntry = async (title, content) => {
        try {
            let resp = await handleSaveJournalChat(authUser?.uid, title, content);
            if (resp) {
                toast.success('Your journal entry has been saved!');
                setSaving(false);
                navigate(-1);
            } else {
                toast.error('Oops! We couldn\'t save your journal entry');
            }
        } catch (err) {
            setSaving(false);
            console.log(err);
        }
    };

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const handleContentChange = (e) => {
        setContent(e.target.value);
    };

    const handleDiscardClick = () => {
        setShowDiscard(true);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    // const handleRecord = () => {
    //     if (!listening) {
    //         lastLength.current = 0;
    //         clear();
    //         start();
    //     } else {
    //         stop();
    //     }
    // };

    // const recordDisabled = saving || connecting || !micAvailable || !micPermissionAllowed;

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 32px)',
        margin: 'auto',
        maxWidth: '600px',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        p: 4,
    };

    return (
        <Stack
            direction='column'
            maxWidth='lg'
            sx={{
                width: '100%',
                height: '100vh',
                margin: `auto`,
            }}
        >
            <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                sx={{ width: '100%', height: '56px', px: '20px', position: 'relative' }}
            >
                <IconButton
                    onClick={handleBackClick}
                    sx={{
                        color: 'primary.main',
                        backgroundColor: 'secondary.light',
                        '&:hover': {
                            backgroundColor: 'secondary.main',
                        },
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>

                <Typography
                    variant='h7'
                    color='text.primary'
                    sx={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        whiteSpace: 'nowrap',
                    }}
                >
                    New Entry
                </Typography>

                <Button
                    variant='contained'
                    color='primary'
                    size='medium'
                    disabled={
                        saving ||
                        title === '' ||
                        content === ''
                        // || listening ||
                        // connecting
                    }
                    onClick={handleSave}
                >
                    {'Save'}
                    {saving && (
                        <CircularProgress size={18} sx={{ position: 'absolute' }} />
                    )}
                </Button>
            </Stack>
            <Divider sx={{ borderColor: 'divider' }} />
            <Box
                display='flex'
                flexDirection='column'
                gap={2}
                width='100%'
                height='100%'
                padding='24px'
            >
                <Box
                    sx={{
                        border: (theme) => `1px solid ${theme.palette.divider}`,
                        padding: '24px',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: { md: 1, xs: 'unset' },
                    }}
                >
                    <TextField
                        placeholder={titlePlaceholder}
                        value={title}
                        onChange={handleTitleChange}
                        // InputProps={{
                        //     readOnly: listening || connecting,
                        // }}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-input': {
                                fontSize: '1.25rem',
                                fontWeight: 'bold',
                                padding: '0px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        }}
                    />

                    <Typography variant='body2' color='textSecondary' paddingBottom='8px'>
                        {timestamp.replace(',', ' @')}
                    </Typography>

                    <TextField
                        multiline
                        minRows={8}
                        placeholder={contentPlaceholder}
                        value={content}
                        onChange={handleContentChange}
                        // InputProps={{
                        //     readOnly: listening || connecting,
                        // }}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-root': {
                                padding: '0px !important',
                            },
                            '& .MuiInputBase-input': {
                                padding: '0px !important',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        }}
                    />
                </Box>

                <Box
                    className='journal-entry-save-btn'
                    width='100%'
                    display='flex'
                    justifyContent='flex-end'
                    alignItems='center'
                >
                    {/* <Box display='flex' alignItems='center' gap={2}>
                        <Button
                            variant="contained"
                            color={errorOccurred ? 'error' : 'secondary'}
                            size="large"
                            onClick={handleRecord}
                            startIcon={
                                listening && !connecting
                                    ? (
                                        <Box
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                border: `2px solid ${theme.palette.error.main}`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '2px',
                                            }}
                                        >
                                        </Box>
                                    )
                                    : <MicIcon />
                            }
                            disabled={recordDisabled || errorOccurred}
                        >
                            {errorOccurred
                                ? 'Error'
                                : connecting
                                    ? 'Connecting...'
                                    : listening
                                        ? 'Stop Recording'
                                        : 'Record Voice'}
                        </Button>

                        <AudioMeter isListening={listening && !connecting} />
                    </Box> */}

                    <Button
                        variant='contained'
                        color='secondary'
                        size='large'
                        disabled={saving
                          // || listening || connecting
                        }
                        startIcon={
                            <DeleteIcon
                                width='18px'
                                height='18px'
                                stroke={
                                    saving
                                    // || listening || connecting
                                        ? theme.palette.action.disabled
                                        : theme.palette.secondary.contrastText
                                }
                            />
                        }
                        onClick={handleDiscardClick}
                    >
                        Discard
                    </Button>
                </Box>
                <Modal
                    sx={{ padding: '16px' }}
                    open={showDiscard}
                    slots={{ backdrop: Backdrop }}
                    slotProps={{ backdrop: { timeout: 500 } }}
                >
                    <Box
                        sx={modalStyle}
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        gap='20px'
                    >
                        <Box display="flex" alignItems="center" gap={1}>
                            <DeleteIcon
                                width='24px'
                                height='24px'
                                stroke={theme.palette.error.main}
                            />
                            <Typography variant="h6" fontWeight="bold">
                                Discard Journal Entry?
                            </Typography>
                        </Box>

                        <Typography variant='body2'>
                            This entry will be lost and your AI Persona will not be updated.
                        </Typography>

                        <Stack
                            direction='row'
                            justifyContent='flex-end'
                            spacing={1.25}
                            paddingTop='32px'
                        >
                            <Button
                                variant='contained'
                                color='error'
                                size='large'
                                onClick={() => {
                                    setShowDiscard(false);
                                    navigate(-1);
                                }}
                            >
                                Discard
                            </Button>

                            <Button
                                variant='contained'
                                color='secondary'
                                size='large'
                                sx={{ borderRadius: '30px', height: '40px !important' }}
                                onClick={() => setShowDiscard(false)}
                            >
                                Continue Editing
                            </Button>
                        </Stack>
                    </Box>
                </Modal>
            </Box>
        </Stack>
    );
};

export default JournalEntryForm;
